import { render } from "./AvatarPreview.vue?vue&type=template&id=770c8203"
import script from "./AvatarPreview.vue?vue&type=script&lang=js"
export * from "./AvatarPreview.vue?vue&type=script&lang=js"

import "./AvatarPreview.vue?vue&type=style&index=0&id=770c8203&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__